// Code generated by AI on 2026-03-23
import { usePermissionsRepository } from '@Hooks/useRepository';
import { InviteToPartnershipRequest } from '@Model';
import { PartnershipsRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';

export function useInviteToPartnership(onAfterInvite: () => void) {
    const partnerships = usePermissionsRepository(PartnershipsRepository);

    return useMutation({
        mutationFn: (request: InviteToPartnershipRequest) => partnerships.inviteToPartnership(request),
        onSuccess: onAfterInvite,
    });
}
